import { LoadableElement } from '@99designs/common/components/LoadableElement';
import { Create } from '__generated__/Create';
import { getLocale } from 'common/utils/getLocale';
import { getRoleFromUser } from 'common/utils/getRole';
import { loadIntlDataForLocale } from 'common/utils/intl';
import { AuthProvider } from 'projects/components/AuthContext';
import CreateContext from 'projects/components/CreateContext';
import ErrorBoundary from 'projects/components/ErrorBoundary';
import Routes from 'projects/routes';
import * as React from 'react';
import { ApolloProvider, Query } from 'react-apollo';
import * as ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import client from './client';
import query from './create.graphql';
import BrowserRouter from './routes/BrowserRouter';

import 'common/polyfill';

// tslint:disable:no-floating-promises
(async () => {
    const locale = getLocale();
    await loadIntlDataForLocale(locale);

    ReactDOM.render(
        <ApolloProvider client={client}>
            <ErrorBoundary>
                <Query<Create> query={query}>
                    {({ loading, error, data }) => {
                        if (loading)
                            return <LoadableElement isLoading={true} variations={['relative ']} />;
                        if (error) throw error;
                        if (data) {
                            return (
                                <CreateContext.Provider
                                    value={{
                                        site: data.site,
                                        role: getRoleFromUser(data.viewer.user),
                                        locale,
                                    }}
                                >
                                    <IntlProvider locale={locale}>
                                        <AuthProvider user={data.viewer.user}>
                                            <ErrorBoundary>
                                                <BrowserRouter>
                                                    <Routes />
                                                </BrowserRouter>
                                            </ErrorBoundary>
                                        </AuthProvider>
                                    </IntlProvider>
                                </CreateContext.Provider>
                            );
                        }
                        return null;
                    }}
                </Query>
            </ErrorBoundary>
        </ApolloProvider>,
        document.querySelector('[data-app]')
    );
})();
